import React, { Component } from "react";
import { connect } from "react-redux";
// import { CloseIcon } from '../common/icons/svg'
import { renderImg } from "../common/icons/img";
let counter = 1;

class Modify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      focus: false,
      isTyping:false, 
    };
  }
  handleKeyPress = (event) => {
    if (this.state.focus) {
      if (event.key === "ArrowDown") {
        if (this.refs["atc" + (counter + 1)]) counter++;
        if (this.refs["atc" + (counter - 1)] && this.refs["atc" + counter])
          this.refs["atc" + (counter - 1)].style = "";
        if (this.refs["atc" + counter]) {
          console.log(this.refs["atc" + counter].style);
          this.refs["atc" + counter].style = "background:#e5e5e5";
          this.refs.atc.scrollTop = (counter - 1) * 37;
        }
      }
      if (event.key === "ArrowUp") {
        if (counter !== 1) counter--;
        if (this.refs["atc" + (counter + 1)] && this.refs["atc" + counter])
          this.refs["atc" + (counter + 1)].style = "";
        if (this.refs["atc" + counter]) {
          this.refs["atc" + counter].style = "background:#e5e5e5";
          this.refs.atc.scrollTop = (counter - 1) * 37;
        }
      }
      if (event.key === "Tab") {
        this.props.setValue(this.refs["atc" + counter].innerHTML, true);
        this.setState({ focus: false });
        counter = 1;
      }
      if (event.key === "Enter") {
        this.props.setValue(this.refs["atc" + counter].innerHTML, true);
        this.setState({ focus: false });
        counter = 1;
      }
    }
  };

  selCity = (city, id) => {
    this.props.setValue(city, id, true, 'selCity');
    this.setState({ focus: false });
  };

  showDropDown = () => {
    if (this.props.list.length > 0) {
      return (
        <div className="atc" ref="atc">
          {this.showAtc(this.props.list)}
        </div>
      );
    } else {
      return (
        <div ref="atc">
          <div>Loading...</div>
        </div>
      );
    }
  };

  showAtc = (list) => {

    let i = 0;
    const city = this.props.value.trim().toLowerCase();
    const { isTyping } = this.state;

    const filteredList = list.filter(el => {
      if (!isTyping) return true; // Show all if not typing

      return (
        el.Name.toLowerCase().startsWith(city) ||
        el.Key.toLowerCase().startsWith(city)
      );
    });

    return filteredList.map((el, index) => {
      if (!el.Name) return null;

      i++;
      return (
        <div key={index} ref={"atc" + i} onClick={() => this.selCity(el.Name, el.ID)}>
          {el.Name}
        </div>
      );
    });
  };

  render() {
    return (
      <div
        style={this.props.style}
        className={this.props.className ? this.props.className : ""}
      >
        <input
          type="text"
          placeholder={this.props.placeholder}
          value={this.props.value}
          onChange={
                    (event) => {
                                this.props.setValue(event.target.value, false);
                                this.setState({ isTyping: true });
                               }
                  }
          onFocus={() => this.setState({ focus: true,isTyping: false })}
          onBlur={() =>
            setTimeout(() => {
              this.setState({ focus: false,isTyping: false });
            }, 500)
          }
          onKeyDown={this.handleKeyPress}
          className={`ty-text ${this.state.focus ? 'inp--focus' : ''}`}
          style={this.props.inpS ? this.props.inpS : this.inpS}
        />
        {this.state.focus ? this.showDropDown() : ""}
        {this.props.label ? <label>{this.props.label}</label> : ""}
        {this.props.value ? (
          <span
            className={this.props.spanclassname ? this.props.spanclassname : ""}
            style={this.clearS}
            onClick={(e) => {
              e.stopPropagation();
              this.props.setValue("", true);
              this.setState({ focus: true });
            }}
          >
            {/* <CloseIcon /> */}
            {renderImg('CloseIcon')}
          </span>
        ) : (
          ""
        )}
      </div>
    );
  }

  inpS = {
    width: "100%",
    background: this.props.err ? "rgba(255, 0, 0, 0.2)" : "#FFFFFF",
    padding: this.props.inputpadding ? this.props.inputpadding : "15px",
    border: "0",
    outline: "0",
    borderRight: this.props.inputborder
      ? this.props.inputborder
      : "1px solid #ddd",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'no-wrap',
  };
}

const mapStateToProps = function (store) {
  return store;
};

export default connect(mapStateToProps)(Modify);
